import React from 'react';
import { pains } from '../data/content';
export function PainSection() {
  return <section className="border-b border-white/5 bg-ink-900 py-16 sm:py-20" aria-labelledby="dolor-title" data-id="element-79" data-mp="38xoher0tacsw">
      <div className="mx-auto max-w-6xl px-5" data-id="element-80" data-mp="2uyotjll4i1xs">
        <div className="max-w-2xl" data-id="element-81" data-mp="2uxvvra456mrs">
          <h2 id="dolor-title" className="font-display text-3xl font-black uppercase leading-tight tracking-tight text-white sm:text-5xl" data-id="element-82" data-mp="2yzqymj1q187o">
            Sabemos lo que sientes...
          </h2>
          <p className="mt-4 text-lg text-white/60" data-id="element-83" data-mp="2pzc6p0u94uv7">
            Porque nosotros también fuimos ese que se quedó parado junto a la entrada, fingiendo revisar el celular.
          </p>
        </div>

        <ul className="mt-10 grid gap-px overflow-hidden rounded-2xl bg-white/10 sm:grid-cols-3" data-id="element-84" data-mp="2g8hny6g7sdei">
          {pains.map(pain => <li key={pain.title} className="flex flex-col bg-ink-850 p-6 sm:p-7" data-id="element-85" data-mp="22a9tc56nho6i">
              <h3 className="font-display text-xl font-extrabold leading-snug text-white" data-id="element-86" data-mp="2779pnodp7ckf">{pain.title}</h3>
              <p className="mt-3 text-[0.95rem] leading-relaxed text-white/55" data-id="element-87" data-mp="3rlfxjpq6h16o">{pain.body}</p>
            </li>)}
        </ul>

        <p className="mt-10 max-w-3xl border-l-2 border-flame pl-5 font-display text-xl font-bold leading-snug text-white sm:text-2xl" data-id="element-88" data-mp="3nns3eowb7cfu">
          El problema nunca fue tu cuerpo. Fue que nadie te dijo qué hacer al entrar.
        </p>
      </div>
    </section>;
}